module.exports = __webpack_public_path__ + "static/img/contract0.595bae1.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/contract0.png
// module id = 901
// module chunks = 1